export default [
  {
    title: 'Data Management',
    customIcon: 'DataManageSVG',
    children: [
      {
        title: 'Summary',
        route: 'data-management-summary',
        path: '/data-management/summary/bcrm_data_management_summary',
      },
      {
        title: 'Customer',
        route: 'data-management-list',
        path: '/data-management/list/Customer_List',
      },
    ],
  },
];
